<template>
  <div>
    <div v-for="(doc, i) in tabs" :key="i">
      <b-card class="px-3 py-2 bg-primary bg-soft" no-body>
        <div class="d-flex align-items-center">
          <h5 class="mb-0 text-primary">{{ doc.name }} : {{ doc.subtitle }}</h5>
          <div class="flex-grow-1"></div>
          <div class="font-size-12">
            {{ doc.created_on || "-" }}
          </div>
        </div>
      </b-card>
      <div class="mb-4">
        <allocating-waiting-list
          :isLast="isLast"
          :hospitals="hospitals"
          :item="item"
          :status="doc.status"
          v-if="isAllocate(doc)"
        ></allocating-waiting-list>
        <generate-provisional-wait-list
          :hospitals="hospitals"
          :status="doc.status"
          :isLast="isLast"
          :item="item"
          v-if="isProvision(doc)"
        ></generate-provisional-wait-list>
        <update-logistics-list
          :item="item"
          v-if="doc.status == 7"
          :isLast="isLast"
        ></update-logistics-list>
        <organ-infection-list
          :item="item"
          v-if="doc.status == 25"
          :isLast="isLast"
        >
        </organ-infection-list>
        <retrieval-list
          :item="item"
          v-if="doc.status == 26"
          :isLast="isLast"
        ></retrieval-list>
        <transplant-surgery
          :item="item"
          :isLast="isLast"
          v-if="doc.status == 28"
        ></transplant-surgery>
        <allocation-list
          :item="item"
          :isLast="isLast"
          v-if="doc.status == 18"
        ></allocation-list>
        <final-allocation-list
          :item="item"
          :isLast="isLast"
          v-if="doc.status == 43"
        ></final-allocation-list>
      </div>
    </div>
  </div>
</template>

<script>
import AllocatingWaitingList from "../create/steps/AllocatingWaitingList.vue";
import GenerateProvisionalWaitList from "../create/steps/GenerateProvisionalWaitList.vue";
import OrganInfectionList from "../create/steps/OrganInfectionList.vue";
import UpdateLogisticsList from "../create/steps/UpdateLogisticsList.vue";
import RetrievalList from "../create/steps/RetrievalList.vue";
import TransplantSurgery from "../create/steps/TransplantSurgery.vue";
import { formatDate } from "../../../assets/js/common";
import AllocationList from "../create/steps/AllocationList.vue";
import FinalAllocationList from "../create/steps/FinalAllocationList.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    history: {
      type: Array,
      default: () => [],
    },
    hospitals: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AllocatingWaitingList,
    GenerateProvisionalWaitList,
    UpdateLogisticsList,
    OrganInfectionList,
    RetrievalList,
    TransplantSurgery,
    AllocationList,
    FinalAllocationList,
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    isLast() {
      return false;
    },
    tabItem() {
      return this.tabs[this.tab] || {};
    },
    tabs() {
      let { organ_allocation_id } = this.item;
      let list = [
        {
          subtitle: "Supra Urgent list",
          status: 31,
        },
        {
          subtitle: "Priority List",
          status: 32,
        },
        {
          subtitle: "Rota 1 List",
          status: 14,
        },
        {
          subtitle: "Priority List",
          status: 22,
        },
        {
          subtitle: "Rota 2 List",
          status: 15,
        },
        {
          subtitle: "Priority List",
          status: 23,
        },
        {
          subtitle: "Rota 3 List",
          status: 16,
        },
        {
          subtitle: "Priority List",
          status: 24,
        },
        {
          subtitle: "Logistics",
          status: 7,
        },
        {
          subtitle: "Assessment Status",
          status: 25,
        },
        {
          subtitle: "Allocation",
          status: 18,
        },
        {
          subtitle: "Organ Retrieval",
          status: 26,
        },
        {
          subtitle: "Final Allocation",
          status: 43,
        },
        {
          subtitle: "Transplant Surgery",
          status: 28,
        },
      ];
      list = list.filter((item, i) => {
        let history = this.history.find((doc) => {
          let status = item.status;
          if (status == 2.1) status = 2;
          if (status == 33.1) status = 33;
          if (status == 4.1) status = 4;
          if (status == 29.1) status = 29;
          return (
            doc.status == status &&
            doc.organ_allocation_id == organ_allocation_id
          );
        });
        if (item.status == 1) return true;
        if (history != null) {
          list[i].created_on = formatDate(history.created_on);
        }
        return history != null;
      });
      return list.map((item, i) => {
        item.name = `Step ${i + 1}`;
        return item;
      });
    },
    fields() {
      let doc = {
        name: "Name",
        email_id: "Email ID / User ID",
        contact_name: "Role",
        phone_number_1: "Phone Number",
        status: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          label: doc[key],
          tdClass: key == "action" ? "width-100" : "",
        });
      });

      return list;
    },
  },
  methods: {
    isAllocate({ status }) {
      return status == 14 || status == 15 || status == 16 || status == 31;
    },
    isProvision({ status }) {
      let allowed = [22, 23, 24, 32];
      return allowed.indexOf(status) != -1;
    },
  },
  mounted() {
    if (this.isMobile) {
      this.tab = this.tabs.length - 1;
      return;
    }
    setTimeout(() => {
      this.tab = this.tabs.length - 1;
    }, 1000);
  },
};
</script>
